import getSupportedLocale, { DEFAULT_LANG } from "@irati/utils/lang/helpers/getSupportedLocale";
import getDeviceLocale from "@irati/utils/lang/helpers/getDeviceLocale";
import getTenantFromPath from "../getTenantFromPath";
var perkboxLogo = "https://res.cloudinary.com/perkbox/image/upload/v1524747023/2811db0a-3811-42d0-804b-ab74e73f00bb.png";
var defaultTenant = {
    Etag: "",
    groupId: "",
    subdomain: getTenantFromPath(),
    locale: getSupportedLocale(getDeviceLocale()) || DEFAULT_LANG,
    settings: {
        featureFlags: "",
        color: "#00adef",
        textColor: "#000",
        imageLink: perkboxLogo,
        welcomeEmail: "",
        signUpOption: "none",
        showSSOOptions: false,
        hideNormalLogin: false,
        employeeName: "",
        ssoButtonText: ""
    }
};
export default defaultTenant;
